import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("pk_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
export const fmt = (n) => `₹${Number(n||0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
